import { PERMISSION_DESCRIPTIONS, PERMISSION_KEYS } from "@convex/permissions";
import { z } from "zod";

// Re-export for backwards compatibility
export const permissionNames = PERMISSION_DESCRIPTIONS;

const permissionShape: {
  [K in (typeof PERMISSION_KEYS)[number]]: z.ZodBoolean;
} = {
  access: z.boolean(),
  viewIntegrations: z.boolean(),
  viewEmployees: z.boolean(),
  addEmployee: z.boolean(),
  editEmployee: z.boolean(),
  viewAllOrders: z.boolean(),
  editAllOrders: z.boolean(),
  addCustomItems: z.boolean(),
  voidKitchenItems: z.boolean(),
  issueRefunds: z.boolean(),
  manageDiscounts: z.boolean(),
  editMenus: z.boolean(),
  editStockStatus: z.boolean(),
  manageCashDrawer: z.boolean(),
};

export const permissionsSchema = z.object(permissionShape);

export const merchantPermissionsSchema = z.object({
  permissionsId: z.string(),
  permissions: permissionsSchema,
});

export const roleSchema = z.object({
  name: z.string(),
  permissions: permissionsSchema,
});
